import React from 'react';
import { Container } from 'react-bootstrap';
import { GetInTouchFooter } from '../panels/LogoFooter';
import { NarrowPage } from '../print/NarrowPage';
import LogoHeader from '../print/LogoHeader';

interface UrlTokenHandlerProps {
  state: 'invalid' | 'too-old';
}

export const InvalidUrlToken: React.FC<UrlTokenHandlerProps> = ({
  state,
}: UrlTokenHandlerProps) => {
  return (
    <div className="d-flex min-vw-100 min-vh-100 flex-column">
      <NarrowPage>
        <LogoHeader />
        <Container className="d-flex flex-column align-items-center" style={{ paddingTop: 64 }}>
          {state === 'too-old' && (
            <>
              <h1 className="step-heading">Link too old!</h1>
              <p>To keep your data safe, our links are only valid for 30 days.</p>
            </>
          )}
          {state === 'invalid' && <h1 className="step-heading">Something went wrong</h1>}
          <p style={{ fontSize: 96 }}>😢</p>

          <p>
            Please <a href="https://www.carboncrop.com/contact">contact us</a> to get a new link.
          </p>
        </Container>
        <GetInTouchFooter />
      </NarrowPage>
    </div>
  );
};
